import { toast } from "react-toastify";
import services from "../../services/services";
import DeleteModalComponent from "../places/modal/DeleteModalComponent";
import { getallBundlesThank } from "../../store/features/getBundlesSlice";
import { useAppDispatch } from "../../store/app/store";
import EditBundule from "../places/modal/EditBundule";
import { ImgUrl } from "../../services/InstanceAxios";
import { getTourName } from "../../services/Tour";

const BundleListRow = ({ bundle }: any) => {
  const dispatch: any = useAppDispatch();

  const deleteBundle = async () => {
    const res: any = await services.deleteBundle(bundle?.id);
    if (res?.status === 200) {
      toast.dismiss();
      toast.success(res?.data?.message || "Bundle deleted");
      dispatch(getallBundlesThank());
    } else {
      toast.error("Something went wrong");
    }
  };

  const retailPrice = Number(bundle?.retailPrice) || 0;
  const sellingPrice = Number(bundle?.sellingPrice) || 0;
  const hasDiscount =
    sellingPrice > 0 && retailPrice > 0 && sellingPrice < retailPrice;
  const currentPrice = sellingPrice || retailPrice;
  const discountPct = hasDiscount
    ? Math.round(((retailPrice - sellingPrice) / retailPrice) * 100)
    : 0;
  const tourCount = bundle?.bundelDetails?.length || 0;
  const name = getTourName(bundle?.name, "en") || "Unnamed bundle";

  return (
    <div className="grid grid-cols-[60px_minmax(0,2.5fr)_100px_minmax(0,1.2fr)_100px] gap-4 items-center px-6 py-3 border-b border-gray-100 hover:bg-gray-50 transition">
      {/* Thumbnail */}
      <div className="w-[60px] h-[60px] rounded-lg overflow-hidden bg-gray-100 flex-shrink-0">
        {bundle?.imageUrl ? (
          <img
            src={ImgUrl + bundle.imageUrl}
            alt={name}
            className="w-full h-full object-cover"
            onError={(e: any) => (e.target.style.visibility = "hidden")}
          />
        ) : null}
      </div>

      {/* Name + product ID */}
      <div className="min-w-0">
        <p className="font-roboto font-bold text-base text-gray-900 truncate">
          {name}
        </p>
        <p className="font-roboto text-xs text-gray-400 truncate mt-0.5">
          {bundle?.productId || "—"}
        </p>
      </div>

      {/* Tour count */}
      <div className="text-sm text-gray-600">
        {tourCount} {tourCount === 1 ? "tour" : "tours"}
      </div>

      {/* Price */}
      <div className="flex items-center gap-2 flex-wrap">
        <span className="font-bold text-aqua text-lg font-Segoe-UI">
          ${currentPrice.toFixed(2)}
        </span>
        {hasDiscount && (
          <>
            <span className="text-xs text-gray-400 line-through">
              ${retailPrice.toFixed(2)}
            </span>
            <span className="text-[10px] bg-aqua bg-opacity-10 text-aqua font-semibold px-1.5 py-0.5 rounded">
              -{discountPct}%
            </span>
          </>
        )}
        {bundle?.published === 0 && (
          <span className="text-[10px] bg-gray-200 text-gray-600 font-semibold px-1.5 py-0.5 rounded">
            DRAFT
          </span>
        )}
      </div>

      {/* Actions */}
      <div className="flex items-center justify-end gap-2">
        <EditBundule data={bundle} />
        <DeleteModalComponent dlFn={deleteBundle} />
      </div>
    </div>
  );
};

export default BundleListRow;
